import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import AgendamentoApi from '@/Apis/Agendamento/Services/AgendamentoApi'
import { TipoDocumentoUpload } from '@/types/_'
import Vue from 'vue'
import RecursosHospitalaresApi from '@/Apis/Agendamento/Services/RecursosHospitalaresApi'

@Module({ namespaced: true, name: 'AvaliacaoRiscoApaStore' })
export default class AvaliacaoRiscoApaStore extends VuexModule {
  showModalAvaliacaoRiscoApa: boolean = false
  avaliacao: any = null
  loading: boolean = false
  solicitacaoId: string | null = null
  public arquivos: any[] = []

  @Mutation
  setShowModalAvaliacaoRiscoApa(value: boolean) {
    this.showModalAvaliacaoRiscoApa = value
  }


  @Mutation
  setAvaliacao(data: any) {
    this.avaliacao = data
  }

  @Mutation
  resetAvaliacaoRiscoApa() {
    this.avaliacao = null
    this.loading = false
    this.showModalAvaliacaoRiscoApa = false
  }

  @Mutation
  setLoading(value: boolean) {
    this.loading = value
  }


  @Mutation
  setSolicitacaoId(id: string) {
    this.solicitacaoId = id
  }

  @Mutation
  resetSolicitacaoId() {
    this.solicitacaoId = null
  }

  @Mutation
  setArquivos(data: any[]) {
    this.arquivos = data
  }

  get getMets() {
    const { avaliacao } = this
    const mets = avaliacao
      && avaliacao.condicoesClinicas
      && avaliacao.condicoesClinicas.capacidadeFuncional
      && avaliacao.condicoesClinicas.capacidadeFuncional.mets
      && avaliacao.condicoesClinicas.capacidadeFuncional.mets.mets

    if (mets === undefined || mets === null) {
      return { valor: '-', cor: 'grey--text text--darken-1' }
    }

    if (mets < 4) return { valor: mets, cor: 'red--text' }
    if (mets >= 4 && mets < 7) return { valor: mets, cor: 'orange--text' }
    if (mets >= 7) return { valor: mets, cor: 'green--text' }

    return { valor: mets, cor: 'grey--text' }
  }

  get getMetsLabel() {
    return (this.avaliacao
      && this.avaliacao.condicoesClinicas
      && this.avaliacao.condicoesClinicas.capacidadeFuncional
      && this.avaliacao.condicoesClinicas.capacidadeFuncional.mets
      && this.avaliacao.condicoesClinicas.capacidadeFuncional.mets.metsLabel
    ) || ''
  }

  get getAsa() {
    const { avaliacao } = this
    const asa = avaliacao
    && this.avaliacao.extratificacaoDeRisco
    && this.avaliacao.extratificacaoDeRisco.asa

    if (asa === undefined || asa === null) {
      return { valor: '-', cor: 'grey--text text--darken-1' }
    }

    if (asa === 'I') return { valor: asa, cor: 'green--text' }
    if (asa === 'II') return { valor: asa, cor: 'green--text' }
    if (asa === 'III') return { valor: asa, cor: 'orange--text' }
    if (asa === 'IV') return { valor: asa, cor: 'red--text' }
    if (asa === 'V') return { valor: asa, cor: 'red--text' }

    return { valor: asa, cor: 'grey--text' }
  }

  get getSort() {
    const { avaliacao } = this
    const sort = avaliacao
    && this.avaliacao.extratificacaoDeRisco
    && this.avaliacao.extratificacaoDeRisco.classificacaoSort

    if (sort === undefined || sort === null) {
      return { valor: '-', cor: 'grey--text text--darken-1' }
    }

    if (sort === 'Baixo') return { valor: sort, cor: 'green--text' }
    if (sort === 'Muito Baixo') return { valor: sort, cor: 'green--text' }
    if (sort === 'Intermediário') return { valor: sort, cor: 'orange--text' }
    if (sort === 'Alto') return { valor: sort, cor: 'red--text' }
    if (sort === 'Muito Alto') return { valor: sort, cor: 'red--text' }

    return { valor: sort, cor: 'grey--text' }
  }

  get getRiscoCirurgico() {
    const { avaliacao } = this
    const mortalityPct = avaliacao
    && this.avaliacao.extratificacaoDeRisco
    && this.avaliacao.extratificacaoDeRisco.mortalityPct
    if (mortalityPct === undefined || mortalityPct === null) {
      return { valor: '-', cor: 'grey--text text--darken-1' }
    }
    if (mortalityPct < 30) return { valor: 'Baixo', cor: 'green--text' }
    if (mortalityPct >= 30 && mortalityPct < 60) return { valor: 'Intermediário', cor: 'orange--text' }
    if (mortalityPct >= 60) return { valor: 'Alto', cor: 'red--text' }
    return { valor: '-', cor: 'grey--text' }
  }


  get getRiscoTotal() {
    const { avaliacao } = this
    const risco = avaliacao
    && this.avaliacao.extratificacaoDeRisco
    && this.avaliacao.extratificacaoDeRisco.riscoProcedimento

    if (risco === undefined || risco === null) {
      return { valor: '-', cor: 'grey--text text--darken-1' }
    }

    if (risco === 'Baixo') return { valor: risco, cor: 'green--text' }
    if (risco === 'Intermediário') return { valor: risco, cor: 'orange--text' }
    if (risco === 'Alto') return { valor: risco, cor: 'red--text' }

    return { valor: risco, cor: 'grey--text' }
  }

  get getMortalitySort() {
    const { avaliacao } = this
    const mortalityPct = avaliacao
    && this.avaliacao.extratificacaoDeRisco
    && this.avaliacao.extratificacaoDeRisco.mortalityPct

    if (mortalityPct === undefined || mortalityPct === null) {
      return { valor: '-', cor: 'grey--text text--darken-1' }
    }

    if (mortalityPct < 30) return { valor: mortalityPct, cor: 'green--text' }
    if (mortalityPct >= 30 && mortalityPct < 60) return { valor: mortalityPct, cor: 'orange--text' }
    if (mortalityPct >= 60) return { valor: mortalityPct, cor: 'red--text' }

    return { valor: mortalityPct, cor: 'grey--text' }
  }

  @Action({ rawError: true })
  async getArquivosAvaliacaoRiscoPreOperatoria(solicitacaoId: string) {
    try {
      this.context.commit('setLoading', true)
      const response = await AgendamentoApi.getAllLaudos(solicitacaoId, TipoDocumentoUpload.AvaliacaoRiscoPreOperatoria)
      if (response.success && Array.isArray(response.data)) {
        this.context.commit('setArquivos', response.data)
      } else {
        this.context.commit('setArquivos', [])
      }
    } catch (error) {
      console.error('Erro ao buscar avaliação:', error)
      throw error
    } finally {
      this.context.commit('setLoading', false)
    }
  }


  @Action({ rawError: true })
  async getAvaliacao({ paramId }: { paramId: string }) {
    try {
      this.context.commit('setLoading', true)
      const { success, data } = await AgendamentoApi.getEstratificacaoById(paramId)

      if (success && data) {
        this.context.commit('setAvaliacao', data)
      } else {
        this.context.commit('setAvaliacao', null)
      }

      return { success: true, data }
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    } finally {
      this.context.commit('setLoading', false)
    }
  }
}
